import { KoPagination, KoTable } from 'packages';
import React, { useState } from 'react';

const ROWS = [
  {
    product: "Earphone G1",
    total: "$302,000",
    payment: "Visa *9082",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Placed"
  },
  {
    product: "TWS Earphone M1",
    total: "$302,000",
    payment: "Bank Transfer",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Placed"
  },
  {
    product: "Mouse Logic G",
    total: "$302,000",
    payment: "Visa *9082",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Processing"
  },
  {
    product: "Berry Samrtwatch",
    total: "$302,000",
    payment: "COD",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Shipping"
  },
  {
    product: "Mouse Logic G",
    total: "$302,000",
    payment: "Visa *9082",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Processing"
  },
  {
    product: "TWS Earphone S2",
    total: "$302,000",
    payment: "Bank Transfer",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Success"
  },
  {
    product: "Ipol Pro S6 5G",
    total: "$302,000",
    payment: "Visa *9082",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Shipping"
  },
  {
    product: "Earphone G1",
    total: "$302,000",
    payment: "Visa *9082",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Canceled"
  },
  {
    product: "Laptop Zen X1",
    total: "$1,200,000",
    payment: "Bank Transfer",
    date: "15 Jan 2024",
    time: "11:20",
    status: "Placed"
  },
  {
    product: "Tablet Nova 11",
    total: "$850,000",
    payment: "Visa *5621",
    date: "15 Jan 2024",
    time: "12:05",
    status: "Success"
  },
  {
    product: "Gaming Chair X-Pro",
    total: "$600,000",
    payment: "COD",
    date: "15 Jan 2024",
    time: "09:30",
    status: "Processing"
  },
  {
    product: "Keyboard Mecha K7",
    total: "$250,000",
    payment: "Visa *7788",
    date: "16 Jan 2024",
    time: "14:15",
    status: "Shipping"
  },
  {
    product: "Monitor UltraView 27",
    total: "$720,000",
    payment: "Bank Transfer",
    date: "16 Jan 2024",
    time: "15:45",
    status: "Placed"
  },
  {
    product: "Powerbank Fast 30k",
    total: "$120,000",
    payment: "Visa *2233",
    date: "17 Jan 2024",
    time: "10:50",
    status: "Canceled"
  },
  {
    product: "Drone SkyMax",
    total: "$2,000,000",
    payment: "Visa *9988",
    date: "17 Jan 2024",
    time: "16:00",
    status: "Success"
  },
  {
    product: "Smart Speaker Echo",
    total: "$150,000",
    payment: "Bank Transfer",
    date: "18 Jan 2024",
    time: "13:25",
    status: "Processing"
  },
  {
    product: "Camera ProShot X9",
    total: "$980,000",
    payment: "Visa *4455",
    date: "18 Jan 2024",
    time: "17:40",
    status: "Placed"
  },
  {
    product: "Smartphone Galaxy Z",
    total: "$1,500,000",
    payment: "COD",
    date: "19 Jan 2024",
    time: "08:10",
    status: "Shipping"
  },
  {
    product: "VR Headset VisionX",
    total: "$450,000",
    payment: "Visa *1122",
    date: "19 Jan 2024",
    time: "19:00",
    status: "Success"
  },
  {
    product: "Portable SSD 2TB",
    total: "$300,000",
    payment: "Bank Transfer",
    date: "20 Jan 2024",
    time: "11:55",
    status: "Placed"
  }
];

const PRO_ITEMS_COLUMNS = [
  {id: "product",label: "PRODUCT",width: 250,fixed: "left",widget:"mediaText"},
  { id: "total", label: "TOTAL", width: 150, widget: "number" },
  { id: "date", label: "DATE", width: 150, widget: "date" },
  { id: "status", label: "CREATED", width: 200, widget: "status" }
];
const CustomerOrder = () => {
  const [totalCount ] = useState(0);
  const [pagination, setPagination ] = useState({
    size: 100,
    page: 1
  });
  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
  };

  return (
    <div>
      
      <KoTable
        rowKey="id"
        minHeight={100}
        data={{
          columns: PRO_ITEMS_COLUMNS,
          rows: ROWS
        }}
      />
      
      <KoPagination current={parseInt(pagination.page) || 1}
        total={totalCount}
        showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
        }
        pageSize={pagination.limit}
        defaultCurrent={pagination.page}
        onChange={onPagination}
        showQuickJumper={false}
        simple={false}
        responsive={false} />
    </div>
  );
};

export default CustomerOrder;